import { render, staticRenderFns } from "./WordStatusTable.vue?vue&type=template&id=cfab953e"
import script from "./WordStatusTable.vue?vue&type=script&lang=js"
export * from "./WordStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports